module.exports = __webpack_public_path__ + "static/media/IPR-en.b258e1ca.PNG";